// var mySwiper = new Swiper('.swiper-container', {
//     loop: true, // 循环模式选项
//     // 如果需要前进后退按钮
//     navigation: {
//         nextEl: '.swiper-right',
//         prevEl: '.swiper-left'
//     }
// })
var onToggleMore = function () {
    document.getElementById('more').classList.toggle('hidden')
    document.getElementById('open').classList.toggle('hidden')
    document.getElementById('close').classList.toggle('hidden')
    if (!document.getElementById('more').classList.contains('hidden')) {
        document.body.style.overflow = 'hidden'
    } else {
        document.body.style.overflow = 'unset'
    }
}

var linkDic = {
    ios: 'https://apps.apple.com/us/app/tanglepay-iota-wallet/id1591026253',
    tf: 'https://testflight.apple.com/join/AsS8Akbv',
    android: 'https://play.google.com/store/apps/details?id=com.cat.iota',
    apk: window.location.origin + '/download/TanglePay-Mobile-V1.6.3.apk?time=' + new Date().getTime(),
    chrome: 'https://chrome.google.com/webstore/detail/tanglepay-iota-wallet/hbneiaclpaaglopiogfdhgccebncnjmc?hl=en-US'
}
// 根据设备判断跳转url
function download(type) {
    if (!type) {
        if (device.ios()) {
            type = 'ios'
        } else if (device.android()) {
            type = 'android'
        } else {
            type = 'chrome'
        }
    }
    if (linkDic[type]) {
        window.open(linkDic[type])
    }
}
/// 锚点
window.anchorClick = function (id) {
    var jump = document.getElementById(id)
    if (jump) {
        window.scrollTo({ top: jump.offsetTop - 20, behavior: 'smooth' })
    }
}

// code related to Trollbox

window.onAccountsChanged = (data) => {
    const newAddress = data.address
    if( walletInfo && walletInfo.address === newAddress) {
        return
    }
    walletInfo = {
        type: 'tanglepay',
        address: newAddress
    }
    setAddress(walletInfo)
}

var setAddress = function (walletInfo) {
    const address = walletInfo?.address
    var dom0 = document.getElementById('connect-btn')
    var dom01 = document.getElementById('connect-btn-1')
    var dom1 = document.getElementById('has-connect-btn')
    var dom11 = document.getElementById('has-connect-btn-1')
    if (address) {
        if (!dom0.classList.contains('hidden')) {
            dom0.classList.add('hidden')
        }
        if (!dom01.classList.contains('hidden')) {
            dom01.classList.add('hidden')
        }
        if (dom1.classList.contains('hidden')) {
            dom1.classList.remove('hidden')
        }
        if (dom11.classList.contains('hidden')) {
            dom11.classList.remove('hidden')
        }
        dom1.querySelector('.address').innerText = address.replace(/(^.{4})(.+)(.{4}$)/, '$1...$3')
        dom11.querySelector('.address').innerText = address.replace(/(^.{4})(.+)(.{4}$)/, '$1...$3')
    } else {
        if (!dom1.classList.contains('hidden')) {
            dom1.classList.add('hidden')
        }
        if (!dom11.classList.contains('hidden')) {
            dom11.classList.add('hidden')
        }
        if (dom0.classList.contains('hidden')) {
            dom0.classList.remove('hidden')
        }
        if (dom01.classList.contains('hidden')) {
            dom01.classList.remove('hidden')
        }
    }
    if (walletInfo) {
        storeWalletInfo(walletInfo)
    }else{
        clearWalletInfo()
    }
}

const iotaEventKey = 'iota_event_accountsChanged'

const storageKey = 'groupfi-wallet-info'
function getWalletInfoFromStorage() {
    const walletInfoStr = window.localStorage.getItem(storageKey)
    if (walletInfoStr) {
        return JSON.parse(walletInfoStr)
    }
    return null
}

function storeWalletInfo(walletInfo) {
    localStorage.setItem(storageKey, JSON.stringify(walletInfo))
}

function clearWalletInfo() {
    localStorage.removeItem(storageKey)
}

let walletInfo = getWalletInfoFromStorage() 

if(walletInfo && walletInfo.address) {
    const len = iota._events.listeners(iotaEventKey).length
    console.log('===> iota_event_accountsChanged length', len)
    if(len === 0) {
        iota._events.on(iotaEventKey, onAccountsChanged)
    }
    setAddress(walletInfo)
}

if(trollbox && walletInfo && walletInfo.type) {
    trollbox.loadTrollbox({walletType: walletInfo.type});
}

let isConnectingWallet = false

window.connectWallet = async function() {
    if (isConnectingWallet) {
        return
    }
    // Ensure iota is ready
    if (iota.isTanglePay && iota.tanglePayVersion !== '') {
        try {
            const res = (await iota.request({
                method: 'iota_connect',
                params: {
                    // expires: 3000000
                },
            }))

            walletInfo = {
                type: 'tanglepay',
                address: res.address
            }

            iota._events.on(iotaEventKey, onAccountsChanged)

            setAddress(walletInfo)
            trollbox.loadTrollbox({walletType: walletInfo.type});
            
        } catch (error) {
            console.log('connectWallet error:', error)
        }
    }else {
        alert("Please install Tanglepay first.")
    }
    // console.log('===>IotaSDK', iota)
    isConnectingWallet = false
}

window.addEventListener('trollbox-ready', async (event) => {

    trollbox.request({
        method: 'setForMeGroups',
        params: {
            includes: ['smr', 'smr-whale', 'soon', 'iceberg-9']
        }
    })

    if (walletInfo) {
        trollbox.dispatchWalletUpdate({
            walletType: 'tanglepay'
        })
    }
})

// window.addJs = function () {
//     var d = document.createElement('script')
//     d.src = `https://prerelease.chat.groupfi.ai/dist/iife/index.js?timestamp=${Date.now()}`
//     if (window.addChatId) {
//         var dom = document.getElementById(window.addChatId)
//         if (dom) {
//             dom.parentNode.removeChild(dom)
//         }
//     }
//     window.addChatId = `tp-js-add-${parseInt(Math.random() * 1000000)}`
//     d.id = window.addChatId
//     document.getElementsByTagName('head')[0].appendChild(d)
//     return window.addChatId
// }

window.removeTrollbox = function () {
    iota._events.removeAllListeners(iotaEventKey)
    
    setAddress(null)
    trollbox.removeTrollbox()
}
